import { isNil } from 'lodash';
import { CellValue } from 'models/interfaces/spreadsheet-types/core-types';

const toString = (value: CellValue, defaultValue = '') => {
  if (isNil(value) || value === Number.POSITIVE_INFINITY) {
    return defaultValue;
  }

  return value.toString();
};

export default toString;
